var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarMortarboard6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83518 7.50194C7.93853 7.54026 8.0542 7.54294 8.1648 7.50194L14.0943 5.27838V10.4047C14.2449 10.3668 14.401 10.3445 14.5631 10.3445C14.7253 10.3445 14.8814 10.3668 15.0319 10.4047V4.92675L15.6968 4.68914C16.1007 4.53731 16.1014 3.96319 15.6968 3.81105L8.1648 0.998284C8.05857 0.958905 7.94137 0.958905 7.83518 0.998284L0.303205 3.81105C-0.100678 3.96288 -0.101459 4.537 0.303205 4.68914L7.83518 7.50194Z",
    fill: "#535A60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5631 11.2812C13.7615 11.2812 13.1567 12.2889 13.1567 13.6252V14.5628C13.1567 14.8219 13.3664 15.0316 13.6255 15.0316H15.5007C15.7598 15.0316 15.9695 14.8219 15.9695 14.5628V13.6252C15.9695 12.2889 15.3648 11.2812 14.5631 11.2812Z",
    fill: "#535A60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8487 6.74616L8.49391 8.37927C8.16773 8.49975 7.82282 8.49657 7.50916 8.38018L3.15118 6.74609C2.76015 8.17916 2.85959 9.11966 2.84319 9.40612C2.84319 9.73774 3.18025 9.96417 3.4855 9.8415C3.4965 9.83738 4.59248 9.40612 5.65595 9.40612C6.64527 9.40612 7.69731 10.2329 7.70784 10.2416C7.87548 10.375 8.11947 10.3794 8.29289 10.2411C8.58317 10.0086 9.51754 9.40609 10.3439 9.40609C11.4074 9.40609 12.5034 9.83735 12.5144 9.84147C12.8189 9.96386 13.1567 9.73834 13.1567 9.40609C13.141 9.13122 13.2374 8.17063 12.8487 6.74616Z",
    fill: "#535A60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarMortarboard6);
export default __webpack_public_path__ + "static/media/sidebar-mortarboard-6.0125cf5c6e84a8b1e0a935a539f9a0c9.svg";
export { ForwardRef as ReactComponent };